module.exports = __webpack_public_path__ + "static/media/loyalty-card.60455e77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loyalty-card.png
// module id = 350
// module chunks = 0